import FullpageController from './Controller/FullpageController';

let Controller = new FullpageController();